module.exports = __webpack_public_path__ + "img/X50-HQ.3fdd8a76.png";